import React from 'react'
import ReactDOM from 'react-dom'

import App from './components/pages/main'


ReactDOM.render(<React.StrictMode><App /></React.StrictMode>, document.getElementById('app'))
